import React from "react";

import { Grid } from "@mui/material";
import { Column } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";

import { Despatch } from "../../../../../../../models/despatch";
import { DespatchViewGridData } from "../GridData";

type DespatchViewShippingItemsProps = {
  despatch: Despatch | null;
};
export const DespatchViewShippingItems: React.FC<DespatchViewShippingItemsProps> = (props) => {
  const { despatch } = props;
  const { t: translate } = useTranslation();

  const columns: Column[] = [
    {
      name: "type",
      title: translate("itemType"),
    },
    {
      name: "description",
      title: translate("description"),
    },
    {
      name: "length",
      title: translate("length"),
    },
    {
      name: "width",
      title: translate("width"),
    },
    {
      name: "height",
      title: translate("height"),
    },
    {
      name: "weight",
      title: translate("weight"),
    },
    {
      name: "volume",
      title: translate("quantity"),
    },
  ];

  return (
    <Grid container direction="column" wrap="nowrap" data-cy="view-shippingitems-container">
      <DespatchViewGridData data={despatch?.shippingItems} columns={columns} />
    </Grid>
  );
};
